(function () {
  // Open the modal window
  jQuery('.js-button-popup').on('click', function () {
    const id = jQuery(this).data('popup');
    jQuery(`.js-overlay[data-id="overlay${id}"]`)
      .css({ display: 'flex', 'justify-content': 'center' })
      .fadeIn();
    jQuery(`.js-video[data-id="video${id}"]`).get(0).play();
  });

  // Close the window by clicking the cross
  jQuery('.js-close-popup').on('click', function () {
    const id = jQuery(this).data('popup');
    jQuery('.js-overlay').fadeOut();
    jQuery(`.js-video[data-id="video${id}"]`).get(0).pause();
  });

  // Close the window by clicking the field
  jQuery('.js-overlay').on('click', function (e) {
    const popup = jQuery('.js-popup');
    const id = jQuery(this).data('popup');
    if (e.target != popup[0] && popup.has(e.target).length === 0) {
      jQuery('.js-overlay').fadeOut();
      jQuery(`.js-video[data-id="video${id}"]`).get(0).pause();
    }
  });

  // Close the window by pressing the Escape key
  window.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      jQuery('.js-overlay').fadeOut();
      jQuery('.js-video').each(function () {
        jQuery(this).get(0).pause();
      });
    }
  });
})();
